export { pastToClipboard as default };
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';

async function pastToClipboard() {
  try {
    return navigator.clipboard.readText().then(text => {
      // this.pasteTarget = text;
      return text;
    }).catch(error => {
      console.error("Error pasting text:", error);
    });
  } catch (e) {
    this.$toast({
      component: core_components_toastification_ToastificationContent_vue,
      props: {
        text: "Sorry, failed to copy, use it manually, please ",
        icon: "EditIcon",
        variant: "warning"
      }
    });
  }
}

